var buildDistanceInWordsLocale = function buildDistanceInWordsLocale(translate, expertFormat) {
  var distanceInWordsLocale = {
    lessThanXSeconds: {
      one: "less than a second",
      other: "less than {0} seconds"
    },
    xSecs: {
      one: "1s",
      other: "{0}s"
    },
    xSeconds: {
      one: "1 second",
      other: "{0} seconds"
    },
    halfAMinute: "half a minute",
    lessThanXMinutes: {
      one: "less than a minute",
      other: "less than {0} minutes"
    },
    xMins: {
      one: "1min",
      other: "{0}mins"
    },
    xMinutes: {
      one: "1 minute",
      other: "{0} minutes"
    },
    aboutXHours: {
      one: "about 1 hour",
      other: "about {0} hours"
    },
    xHrs: {
      one: "1hr",
      other: "{0}hrs"
    },
    xHours: {
      one: "1 hour",
      other: "{0} hours"
    },
    xDays: {
      one: "1 day",
      other: "{0} days"
    },
    aboutXMonths: {
      one: "about 1 month",
      other: "about {0} months"
    },
    xMonths: {
      one: "1 month",
      other: "{0} months"
    },
    aboutXYears: {
      one: "about 1 year",
      other: "about {0} years"
    },
    xYears: {
      one: "1 year",
      other: "{0} years"
    },
    overXYears: {
      one: "over 1 year",
      other: "over {0} years"
    },
    almostXYears: {
      one: "almost 1 year",
      other: "almost {0} years"
    }
  };

  var localize = function localize(token, count) {
    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    var result;

    if (typeof distanceInWordsLocale[token] === "string") {
      result = translate(distanceInWordsLocale[token]);
    } else if (count === 1) {
      result = translate(distanceInWordsLocale[token].one);
    } else {
      result = translate(distanceInWordsLocale[token].other, count);
    }

    if (options.comparison > 0) {
      if (expertFormat) {
        return translate("{0} left", result);
      } else {
        return translate("in ") + result;
      }
    } else {
      if (options.hideSuffix) {
        return result;
      }

      return result + translate(" ago");
    }
  };

  return {
    localize: localize
  };
};

export var locale = function locale(translate) {
  var expertFormat = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  return {
    distanceInWords: buildDistanceInWordsLocale(translate, expertFormat)
  };
};